export class DtoAreaGom {
    Codigo: string = '';
    Descripcion: string = '';
}